import { render, staticRenderFns } from "./DeleteTagAlert.vue?vue&type=template&id=356bfce6"
import script from "./DeleteTagAlert.vue?vue&type=script&lang=js"
export * from "./DeleteTagAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports